import SignaturePad from "signature_pad";

let signatures = [];

// Initialize signature pad
document.addEventListener('signature', function (event) {
    const canvases = document.querySelectorAll("canvas");

    if (canvases.length === 0) {
        return;
    }

    canvases.forEach(function (canvas) {
        signatures[canvas.getAttribute('id')] = new SignaturePad(canvas);

        let inputSignature = document.querySelector('input[name="' + canvas.getAttribute('id') + '"]');

        // If signature exists put into canvas
        if (inputSignature.value !== '') {
            signatures[canvas.getAttribute('id')].fromDataURL(inputSignature.value);
        }

        // When end drawing append to input
        signatures[canvas.getAttribute('id')].addEventListener('endStroke', function () {
            inputSignature.value = signatures[canvas.getAttribute('id')].toDataURL();
            inputSignature.dispatchEvent(new Event('input'));
        });
    });
});

document.addEventListener('clearMembershipSignature', function () {
    const membershipSignature = document.querySelector("canvas#membershipSignature");
    signatures['membershipSignature'] = new SignaturePad(membershipSignature);

    if (signatures['membershipSignature']) {
        signatures['membershipSignature'].clear();
    }
});

document.addEventListener('clearRegistrationSignature', function () {
    const registrationSignature = document.querySelector("canvas#registrationSignature");
    signatures['registrationSignature'] = new SignaturePad(registrationSignature);

    if (signatures['registrationSignature']) {
        signatures['registrationSignature'].clear();
    }
});

document.addEventListener('clearWithdrawalSignature', function () {
    const withdrawalSignature = document.querySelector("canvas#withdrawalSignature");
    signatures['withdrawalSignature'] = new SignaturePad(withdrawalSignature);

    if (signatures['withdrawalSignature']) {
        signatures['withdrawalSignature'].clear();
    }
});


